import {Injectable} from '@angular/core';
import {ModalComponent} from 'app/shared/components/modal/modal.component';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    open(modal: ModalComponent, event?: MouseEvent) {
        modal.open();

        if (event) {
            let item = document.getElementsByClassName('modal')[0];
            item['style'].top = event.pageY + 'px';
            item['style'].left = event.pageX + 'px';
        }
    }

    close(modal: ModalComponent) {
        if (!modal) {
            return;
        }

        modal.close();
    }
}
